import { useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'
import { getVehiclesList } from './getVehiclesList'
import { QUERY_KEY_CONFIG_COUNTRIES } from '../../constants'
import { VehiclesResponse, PaginatedVehiclesResponse } from './types'

type Props = {
  companyId: string
  page?: number
  pageSize?: number
  groupId?: number
  isActive?: boolean
  search?: string
  enabled?: boolean
}

/**
 * Fetches vehicles list with optional pagination and filtering.
 */
export function useQueryVehiclesList(props: Props) {
  const { companyId, page, pageSize, groupId, isActive, search, enabled = true } = props
  
  return useQuery<VehiclesResponse | PaginatedVehiclesResponse>({
    // Discriminate from the drivers/countries queries — those share
    // QUERY_KEY_CONFIG_COUNTRIES as their prefix, which collides with this one
    // on identical args (companyId / pageSize / isActive / search) and made
    // React Query dedupe vehicles into the same cache entry as drivers, so the
    // vehicles request never fired on chart load.
    queryKey: [QUERY_KEY_CONFIG_COUNTRIES, 'vehicles', companyId, page, pageSize, groupId, isActive, search],
    queryFn: async () => {
      const { data } = await getVehiclesList(props)
      return data
    },
    enabled,
    staleTime: MINUTE_IN_MS * 60, // cache for 60 minutes
  })
}
